<div class="mt-4" fxLayout="column" fxLayoutGap="14px" class="app-full-height px-4 pt-4" cdkScrollable>
  <div *ngIf="booking?.docket_id; else warnings" id="transferred-warning" (click)="goToDocket()"
    class="bg-red-100 border border-red-700 text-red-700 px-4 py-3 mb-3" role="alert">
    <p class="font-bold">Warning</p>
    <p class="text-sm">
      This booking has been converted to a hire contract, click here to view the
      hire contract.
    </p>
  </div>
  <ng-template #warnings>
    <div *ngIf="booking?.status === availableStatuses.QUOTATION" id="quotation-notice"
      class="bg-blue-100 border border-blue-700 text-blue-700 px-4 py-3 mb-3" role="alert">
      <p *ngIf="!booking.deposit_amount" class="text-sm">
        A quotation for this booking was sent to the customer and is pending
        acceptance.
      </p>
      <p *ngIf="booking.deposit_amount" class="text-sm">
        A quotation and deposit request of
        {{ booking.deposit_amount | currency: currency : 'symbol' : '1.2-2' }}
        for this booking was sent to the customer and is pending acceptance.
      </p>
      <p>
        You can continue to modify the booking until it is converted to a Hire
        Contract.
      </p>
    </div>
    <div *ngIf="booking?.status === availableStatuses.CANCELLED" id="cancelled-warning"
      class="bg-red-100 border border-red-700 text-red-700 px-4 py-3 mb-3" role="alert">
      <p class="font-bold">Warning</p>
      <p class="text-sm">This booking has been cancelled</p>
    </div>
    <div *ngIf="booking?.status === availableStatuses.REQUEST" id="request-notice"
      class="bg-green-100 border border-green-700 text-green-700 px-4 py-3 mb-3" role="alert">
      <p class="font-bold">Pending Quotation</p>
      <p class="text-sm">
        The customer is waiting for a reply from you about this booking, please
        provide a quotation and deposit request (if applicable).
      </p>
    </div>
  </ng-template>
  <div fxLayout="column" fxLayout.gt-sm="row" *ngIf="booking" fxLayoutGap="14px">
    <mat-card appearance="outlined" fxLayout.gt-sm="column" fxFlex.gt-sm="30" fxFlexOrder.gt-sm="2" fxLayoutGap="12px"
      fxLayout="column" fxFlex="auto" fxLayoutAlign="center center">
      <mat-card-content class="flex flex-col space-x-3 justify-center items-center text-center">
        <h2>Hire Booking - {{ booking.id }}</h2>
        <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="center center">
          <booking-status [status]="booking?.status"></booking-status>
          <span data-cy="source">Source: {{ booking.source | titlecase }}</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="center start">
          <button matTooltip="Print" color="primary" mat-icon-button *ngIf="hasItems" (click)="print()">
            <mat-icon>print</mat-icon>
          </button>
          <button matTooltip="Download" color="primary" mat-icon-button *ngIf="hasItems" (click)="print(true)">
            <mat-icon>file_download</mat-icon>
          </button>
          <button matTooltip="Email" color="primary" mat-icon-button *ngIf="hasItems" (click)="email()">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" fxLayout="column" fxFlex.gt-sm="35" fxLayoutAlign="center stretch" fxFlex="auto"
      fxFlexOrder.gt-sm="1">
      <mat-card-content>
        <h2>Customer</h2>
        <div class="flex flex-row justify-start items-center md:justify-between gap-x-4">
          <p>
            <a data-cy="customer-name" *ngIf="booking" matTooltip="View Customer" matTooltip-position="right"
              md-autohide="false" routerLink="/customer/{{ booking?.customer_id }}">
              {{ booking?.customer | customerName }}
            </a>
          </p>
          <button mat-stroked-button (click)="changeCustomer()">Change</button>
        </div>
        <p>{{ booking?.customer | customerAddress }}</p>
        <p class="break-words">
          {{ booking?.customer | customerContactDetails }}
        </p>
        <app-document-contact [contactId]="booking?.contact_id" [customerId]="booking?.customer_id"
          (contactSelected)="updateBookingContact($event)"></app-document-contact>
        <app-integration-relationship-info [customer]="booking?.customer"></app-integration-relationship-info>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" fxFlex.gt-sm="35" fxFlex="auto" fxFlexOrder.gt-sm="3">
      <mat-card-content class="flex flex-col space-x-3 justify-center items-center text-center space-y-3">
        <div class="flex flex-row justify-center items-center space-x-3">
          <button mat-flat-button color="primary" *ngIf="booking.status === availableStatuses.REQUEST"
            [disabled]="booking?.docket_id !== null" (click)="openReplyDialog()">
            Send Quote
          </button>
          <button mat-flat-button color="primary" data-cy="convert-button"
            *ngIf="booking.status === availableStatuses.CUSTOMER_ACCEPTED" [disabled]="booking?.docket_id !== null"
            (click)="openConvertDialog()">
            Convert to Hire contract
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="booking?.docket_id !== null"
            [testId]="testIds.BOOKING_OPTIONS_MENU">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (booking.status === availableStatuses.CANCELLED) {
            <button mat-menu-item *ngIf="booking.status === availableStatuses.CANCELLED" (click)="updateToRequest()">
              Update to Active Quotation
            </button>
            <button mat-menu-item (click)="updateAccepted()">
              Update to Customer Accepted
            </button>
            } @else {
            <button mat-menu-item (click)="openReplyDialog()" *ngIf="booking.status !== availableStatuses.REQUEST">
              Send Quotation/Deposit Request
            </button>
            <button mat-menu-item *ngIf="booking.status !== availableStatuses.CUSTOMER_ACCEPTED"
              (click)="updateAccepted()">
              Update to Customer Accepted
            </button>
            <button mat-menu-item *ngIf="booking.status !== availableStatuses.CUSTOMER_ACCEPTED"
              (click)="openConvertDialog()">
              Convert to Hire Contract
            </button>
            <button mat-menu-item [testId]="testIds.CANCEL_BOOKING_BUTTON"
              *ngIf="booking.status !== availableStatuses.COMPLETED" (click)="updateCancelled()">
              Cancel Booking
            </button>
            }
          </mat-menu>
        </div>
        <div class="flex flex-row justify-center items-center space-x-3">
          <app-key-value-pair name="Purchase Order" [value]="booking.purchase_order"></app-key-value-pair>
          <button mat-icon-button (click)="editPo()">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card appearance="outlined" fxLayout="column" *ngIf="booking" fxLayoutAlign="start stretch">
    <mat-card-title fxFlexAlign="center">
      <h2>Hire Items</h2>
    </mat-card-title>
    <mat-card-content fxLayout="column" fxLayoutGap="14px">
      <div class="x-auto" *ngIf="items$ | async as items">
        <table class="table table-striped" [testId]="testIds.BOOKING_TABLE" *ngIf="items.length > 0"
          [testId]="testIds.BOOKING_TABLE">
          <thead>
            <tr>
              <th>Qty</th>
              <th>Product</th>
              <th>On Hire</th>
              <th>Off Hire</th>
              <th>Delivery/Collection</th>
              <th>Price</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let bookingItem of items; let index = index">
              <tr class="group" *ngIf="!bookingItem.deleted_at" [testId]="testIds.BOOKING_TABLE_ROW">
                <td>
                  <div class="flex flex-row justify-start items-center gap-x-2">
                    <p>
                      {{ bookingItem.quantity }}
                    </p>
                    <mat-icon *ngIf="bookingItem?.conflict_level" testId="stock-warning" [ngClass]="{
                        'text-red-500': bookingItem.conflict_level === 2,
                        'text-yellow-500': bookingItem.conflict_level === 1,
                        'pt-1 cursor-pointer': true
                      }" (click)="openConflicts(bookingItem.id, bookingItem.children.length > 0)" [matTooltip]="
                        bookingItem.conflict_level === 2
                          ? 'Insufficient Stock'
                          : 'Conflicts exist'
                      ">warning
                    </mat-icon>
                  </div>
                </td>
                <td class="product-name">
                  <ng-container *ngIf="bookingItem.item; else productCategoryLabels">
                    <a matTooltip="View Product" matTooltip-position="left" tooltipHideDelay="0" [routerLink]="[
                        '/product/',
                        bookingItem.product.id,
                        { type: 'hire' }
                      ]">
                      {{ bookingItem.product.name }}
                    </a>
                    -
                    <a matTooltip="View Item" matTooltip-position="left" tooltipHideDelay="0"
                      (click)="showItemDialog(bookingItem.item)">
                      {{ bookingItem.item.code }}
                    </a>
                  </ng-container>
                  <ng-template #productCategoryLabels>
                    <a *ngIf="bookingItem.product; else categoryLabel" matTooltip="View Product"
                      matTooltip-position="left" tooltipHideDelay="0" [routerLink]="[
                        '/product/',
                        bookingItem.product.id,
                        { type: 'hire' }
                      ]">
                      {{ bookingItem.product.name }}
                    </a>
                    <ng-template #categoryLabel>
                      <a matTooltip="View Category" matTooltip-position="left" tooltipHideDelay="0" [routerLink]="[
                          '/product/category/',
                          bookingItem.category.id
                        ]">
                        {{ bookingItem.category.name }}
                      </a>
                    </ng-template>
                  </ng-template>
                  <p *ngIf="bookingItem.item && bookingItem.item.notes">
                    <small><strong>Item details:</strong>
                      {{ bookingItem.item.notes }}</small>
                  </p>
                  <p>
                    <small><strong>Notes:</strong> {{ bookingItem.notes }}</small>
                  </p>
                </td>
                <td class="on-hire" width="20%">
                  {{ bookingItem.on_hire | amDateFormat: dateTimeFormat }}
                </td>
                <td class="off-hire" width="20%">
                  <span *ngIf="bookingItem.off_hire">
                    {{ bookingItem.off_hire | amDateFormat: dateTimeFormat }}
                  </span>
                </td>
                <td>
                  <ng-container *ngIf="bookingItem.location_id; else deliver">
                    Collect from
                    {{ bookingItem.location_id | locationNameFromId | async }}
                  </ng-container>
                  <ng-template #deliver> Delivery Required</ng-template>
                </td>
                <td class="charge" width="10%">
                  <div class="flex flex-col">
                    @if (bookingItem.charge !== null) {
                    <div class="flex flex-row justify-start items-center">
                      <p *ngIf="bookingItem.charge || bookingItem.charge === 0">
                        {{
                        bookingItem.charge
                        | currency: currency : 'symbol' : '1.2-2'
                        }}
                      </p>
                      <button class="group-hover:visible group-active:visible invisible" mat-icon-button
                        (click)="openPriceSettings(bookingItem)">
                        <mat-icon>settings</mat-icon>
                      </button>
                    </div>
                    <span data-cy="price-breakdown" *ngIf="
                        bookingItem.price_suggestion?.estimate &&
                        bookingItem.price_suggestion.estimate.price.toString() ===
                          bookingItem.charge.toString()
                      ">
                      <small>
                        {{
                        bookingItem.price_suggestion
                        | priceEstimateBreakdown
                        : currency
                        : 1
                        : bookingItem.quantity
                        }}
                      </small>
                    </span>
                    } @else {
                    <p>No charge set</p>
                    }
                  </div>
                </td>
                <td class="hire-item-options" width="10%">
                  <span class="group-hover:visible group-active:visible invisible" *ngIf="
                      booking.status !== availableStatuses.CANCELLED &&
                      !booking?.docket_id
                    ">
                    <a (click)="showEditBookingItemDialog(bookingItem)">Edit</a>
                    <span class="text-gray"> | </span>
                    <a (click)="deleteHireItem(bookingItem)">Delete</a>
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="100" fxFlex.gt-sm="40" class="bg-green-50 border-green-900 border rounded py-6 my-12 px-8" *ngIf="
            !booking.docket_id &&
              booking.status !== availableStatuses.CANCELLED;
            else bookingClosed
          ">
          <item-search (optionSelected)="productSelected($event)" searchType="booking"></item-search>
        </div>
        <ng-template #bookingClosed>
          <div class="bg-red-100 border border-red-700 text-red-700 px-4 py-3 mb-3 text-center">
            <ng-container *ngIf="booking.docket_id">
              <span id="docket-closed">This booking has been moved to a hire contract.</span>
            </ng-container>
            <ng-container *ngIf="booking.status === availableStatuses.CANCELLED">
              <span id="docket-cancelled">This booking has been cancelled.</span>
            </ng-container>
          </div>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" fxLayout="column" fxLayoutAlign="start stretch">
    <mat-card-content fxLayout="column" fxLayoutGap="14px" fxLayoutAlign="start stretch">
      <mat-card-title fxFlexAlign="center">
        <h2>Consumables</h2>
      </mat-card-title>
      <div class="w-full overflow-x-auto">
        <app-retail-item-list [docketId]="booking?.id" [canAdd]="booking?.docket_id === null"
          [canEdit]="booking?.docket_id === null" [parentType]="'booking'"
          [showGridButton]="true"></app-retail-item-list>
      </div>
    </mat-card-content>
  </mat-card>
  <div fxLayout="column" fxLayout.gt-sm="row" *ngIf="hasItems" fxLayoutGap="16px">
    <div fxLayout="column" fxLayoutGap="16px" fxFlex.gt-sm="70">
      <div class="border border-gray-300 p-3" fxLayout="column" fxLayoutGap="14px">
        <app-signature-section [booking]="booking" [stage]="
            booking.status === availableStatuses.REQUEST
              ? 'Quotation'
              : 'Booking'
          "></app-signature-section>
      </div>
      <deliveries deliverableType="booking" [deliverableId]="booking.id"
        [deliverableCustomerAddress]="booking.customer | customerAddress" [defaultCurrency]="currency"
        [canAdd]="!booking.docket_id && booking.status !== availableStatuses.CANCELLED" [canEdit]="true"
        (deliveriesUpdated)="deliveryListItems.next($event)" [refreshDeliveryData$]="refreshDataDependentOnHireItems$">
      </deliveries>
    </div>
    <app-price-wrapper fxFlex.gt-sm="30" [booking]="booking" [bookingItems]="items$ | async"
      [deliveries]="deliveryListItems$ | async">
    </app-price-wrapper>
  </div>


  <app-comments-and-emails [source]="emailListSource$ | async">
    <app-comments type="booking" [id]="booking?.id" [comments]="booking?.comments"></app-comments>
  </app-comments-and-emails>

  <!--<pdf-viewer *ngIf="printUrl" [src]="printUrl"></pdf-viewer>-->
  <iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>
</div>